export const enum ItinerarySegmentType {
  // Bookable product segments
  Accommodation = 'accommodation',
  Activity = 'activity',
  Ferry = 'ferry',
  Flight = 'flight',

  // Unbookable segments
  OwnStay = 'ownStay',
  Car = 'car',
  Cycle = 'cycle',
  Walk = 'walk',
  NoTransport = 'noTransport',

  // Dates segments
  StartLocation = 'startLocation',
  DateLocation = 'dateLocation',
  EndLocation = 'endLocation',

  // Upsell segments
  AccommodationUpsell = 'accommodationUpsell',
  AccommodationUpsellLoader = 'accommodationUpsellLoader',
  Upsell = 'upsell',
  UpsellNoTransport = 'upsellNoTransport',
}
